// extracted by mini-css-extract-plugin
module.exports = {"root":"Swatch_root__MxgID","active":"Swatch_active__ThJ5g","item":"Swatch_item__PGg2Z","disabled":"Swatch_disabled__Fi25E"};